import React from 'react';

import './grid-line.scss';



const GridLine = ({ children }) => {

  return (
      <div className="p-v3-grid-line p-v5-grid-line"
      >
        { children }
      </div>
  );
}

export default GridLine;
